import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { T3CHAT_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function T3ChatAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="t3.chat Alternative — Multi-Model Super Intelligence App"
      description="A t3.chat alternative with GPT, Claude, Gemini, and Arya — plus images, video, music, and private apps on Gab AI."
      canonical="/t3chat-alternative"
      keywords="t3.chat alternative, t3chat alternative, alternative to t3.chat, t3 chat alternative, better than t3.chat, t3.chat competitor, apps like t3.chat, free t3.chat alternative, best t3.chat alternative"
      page={T3CHAT_ALTERNATIVE}
    />
  );
}